import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { businessesApi, BusinessSearchParams } from '@api/endpoints/businesses'

export function useBusinesses(params: BusinessSearchParams) {
  return useQuery({
    queryKey: ['marketing', 'businesses', params],
    queryFn: () => businessesApi.search(params),
    staleTime: 1000 * 60 * 2,
    placeholderData: keepPreviousData,
  })
}
